import axios from 'axios'

// Get all transactions for business
const send = async (customers) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/mail/ticket/resend`, customers)
  return data
}

// Get all transactions for business
const businessUpdate = async (message) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/mail/business/update`, { message })
  return data
}

export {
  send,
  businessUpdate
}
